import React from "react";
import { BrowserRouter, Switch, Redirect } from "react-router-dom";

import Route from "./Route";
import { AuthProvider } from "../context/Auth/AuthContext";
import { ProjectProvider } from "../context/Project/ProjectContext";
import { ChatProvider } from "../context/Chat/ChatContext";
import { WebPhoneProvider } from "../context/WebPhone/WebPhoneContext";
import Layout from "../layout";
import Login from "../pages/Login";
import Sso from "../pages/Sso";
import McpSetup from "../pages/McpSetup";
import Recepcao from "../pages/Recepcao";
import Chat from "../pages/Chat";
import Numbers from "../pages/Numbers";
import Applications from "../pages/Applications";
import Builder from "../pages/Applications/Builder";
import Events from "../pages/Events";
import Alerts from "../pages/Alerts";
import Connectors from "../pages/Connectors";
import ConnectorEvents from "../pages/Connectors/ConnectorEvents";
import CollectorsList from "../pages/Collectors/CollectorsList";
import Jobs from "../pages/Jobs";
import Vault from "../pages/Vault";
import Data from "../pages/Data";
import Datasets from "../pages/Datasets";
import DatasetView from "../pages/Datasets/DatasetView";
import DatasetReports from "../pages/Datasets/DatasetReports";
import ReportBuilder from "../pages/Datasets/ReportBuilder";
import Extensions from "../pages/Extensions";
import Storage from "../pages/Storage";
import Templates from "../pages/Templates";
import TemplateView from "../pages/Templates/TemplateView";
import Developers from "../pages/Developers";
import Agents from "../pages/Agents";
import Schedules from "../pages/Schedules";
import Cdrs from "../pages/Cdrs";
import Settings from "../pages/Settings";
import Plans from "../pages/Plans";
import Billing from "../pages/Billing";
import AdminOverview from "../pages/Admin/Overview";
import AdminUsers from "../pages/Admin/Users";
import AdminUserDetail from "../pages/Admin/UserDetail";
import AdminRevenue from "../pages/Admin/Revenue";
import AdminOperations from "../pages/Admin/Operations";
import AdminTelephony from "../pages/Admin/Telephony";
import AdminPlans from "../pages/Admin/Plans";
import AdminAwsCosts from "../pages/Admin/AwsCosts";

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/sso" component={Sso} />
          <Route exact path="/conectar-mcp" component={McpSetup} isPrivate />
          <Route exact path="/recepcao" component={Recepcao} isPrivate />
          <ProjectProvider>
          <ChatProvider>
          <WebPhoneProvider>
          <Layout>
            <Switch>
              <Route exact path="/" component={Chat} isPrivate />
              <Route exact path="/chat" component={Chat} isPrivate />
              <Route exact path="/chat/:conversationId" component={Chat} isPrivate />
              <Route exact path="/numbers" component={Numbers} isPrivate />
              <Route exact path="/cdrs" component={Cdrs} isPrivate />
              <Route exact path="/applications" component={Applications} isPrivate />
              <Route exact path="/templates" component={Templates} isPrivate />
              <Route exact path="/templates/:id" component={TemplateView} isPrivate />
              <Route
                exact
                path="/applications/:applicationId"
                component={Builder}
                isPrivate
              />
              <Route exact path="/events" component={Events} isPrivate />
              <Route exact path="/alerts" component={Alerts} isPrivate />
              <Route exact path="/connectors" component={Connectors} isPrivate />
              <Route exact path="/connectors/:connectorId/events" component={ConnectorEvents} isPrivate />
              <Route exact path="/collectors" component={CollectorsList} isPrivate />
              <Route exact path="/jobs" component={Jobs} isPrivate />
              <Route exact path="/jobs/:jobId" component={Jobs} isPrivate />
              <Route exact path="/vault" component={Vault} isPrivate />
              <Route exact path="/datasets" component={Datasets} isPrivate />
              <Route exact path="/datasets/:id" component={DatasetView} isPrivate />
              <Route exact path="/datasets/:id/reports" component={DatasetReports} isPrivate />
              <Route exact path="/datasets/:id/report" component={ReportBuilder} isPrivate />
              <Route exact path="/datasets/:id/report/:rid" component={ReportBuilder} isPrivate />
              <Route exact path="/data" component={Data} isPrivate />
              <Route exact path="/extensions" component={Extensions} isPrivate />
              <Route exact path="/storage" component={Storage} isPrivate />
              {/* hub do desenvolvedor (sub-rotas internas) */}
              <Route path="/developers" component={Developers} isPrivate />
              {/* agentes de IA (lista de agentes + ferramentas) */}
              <Route path="/agents" component={Agents} isPrivate />
              {/* agendamentos: apps com gatilho "Agendado" */}
              <Route exact path="/schedules" component={Schedules} isPrivate />
              {/* configurações do usuário (perfil + telefone verificado/OTP) */}
              <Route exact path="/settings" component={Settings} isPrivate />
              {/* planos / assinatura */}
              <Route exact path="/plans" component={Plans} isPrivate />
              <Route exact path="/billing" component={Billing} isPrivate />
              <Route exact path="/admin" component={AdminOverview} isPrivate isStaff />
              <Route exact path="/admin/users" component={AdminUsers} isPrivate isStaff />
              <Route exact path="/admin/revenue" component={AdminRevenue} isPrivate isStaff isGovernance />
              <Route exact path="/admin/operations" component={AdminOperations} isPrivate isStaff />
              <Route exact path="/admin/telephony" component={AdminTelephony} isPrivate isStaff />
              <Route exact path="/admin/plans" component={AdminPlans} isPrivate isStaff isGovernance />
              <Route exact path="/admin/aws-costs" component={AdminAwsCosts} isPrivate isStaff isGovernance />
              <Route exact path="/admin/users/:id" component={AdminUserDetail} isPrivate isStaff />
              {/* compat: páginas que viraram seções do hub */}
              <Redirect exact from="/secrets" to="/developers/keys" />
              <Redirect exact from="/webhooks" to="/developers/webhooks" />
              <Redirect exact from="/usage" to="/developers/usage" />
              {/* projetos foram unificados na página de aplicações */}
              <Redirect exact from="/projects" to="/applications" />
              <Redirect to="/numbers" />
            </Switch>
          </Layout>
          </WebPhoneProvider>
          </ChatProvider>
          </ProjectProvider>
        </Switch>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
